import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Loading02 = function Loading02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 2v4m0 12v4M6 12H2m20 0h-4m1.0784 7.0784L16.25 16.25M19.0784 5 16.25 7.8283m-11.3284 11.25L7.75 16.25M4.9216 5 7.75 7.8283"
    })
  }));
};
export default Loading02;